module.exports = __webpack_public_path__ + "img/contacto.c29054fb.jpg";